"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var FinanceWithdrawList_1 = require("./component/FinanceWithdrawList");
var PFinanceWithdrawsList = /** @class */ (function (_super) {
    __extends(PFinanceWithdrawsList, _super);
    function PFinanceWithdrawsList(props) {
        return _super.call(this, props) || this;
    }
    PFinanceWithdrawsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.brandsData.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AW = this.props.withdrawTypesData.Subscribe("*", function (id, data) {
            _this.setState({ avail_withdraw_types: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize,
                all_withdraw_types: data.all_withdraw_types,
                withdraw_types_list: data.withdraw_types_list
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_withdraw_types: [],
            withdraw_types_list: this.props.state.getWithdrawTypesList(),
            all_withdraw_types: this.props.state.getIsAllWithdrawTypes()
        }, function () {
            _this.props.brandsData.LoadData();
            _this.props.withdrawTypesData.LoadData();
        });
    };
    PFinanceWithdrawsList.prototype.componentWillUnmount = function () {
        this.props.brandsData.UnSubscribe(this.SID_AB);
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.withdrawTypesData.UnSubscribe(this.SID_AW);
    };
    PFinanceWithdrawsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PFinanceWithdrawsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PFinanceWithdrawsList.prototype.onWithdrawTypeFilterChanged = function (allWithdrawTypes, WithdrawTypeCode, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllWithdrawTypes(allWithdrawTypes, true);
        }
        if (Action === "add") {
            this.props.state.addWithdrawType(WithdrawTypeCode, true);
        }
        if (Action === "remove") {
            this.props.state.delWithdrawType(WithdrawTypeCode, true);
        }
    };
    PFinanceWithdrawsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(FinanceWithdrawList_1.default, { data: this.props.data, state: this.props.state, onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), withdrawTypesList: this.state.withdraw_types_list, allWithdrawTypes: this.state.all_withdraw_types, availWithdrawTypes: this.state.avail_withdraw_types, onWithdrawTypeFilterChanged: this.onWithdrawTypeFilterChanged.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PFinanceWithdrawsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PFinanceWithdrawsList.getPageDescription = function (state) {
        return {
            icon: "wallet",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_finance_withdraws_list + "-id",
            itemTitle: "Выплаты",
            route: routes_1.routes.page_finance_withdraws_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PFinanceWithdrawsList;
}(React.Component));
exports.default = PFinanceWithdrawsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_withdraws_list/ui/PFinanceWithdrawsList.tsx
// module id = 1991
// module chunks = 0